import b from 'b_';
import cx from 'classnames';
import React, { useCallback, useEffect, useRef, useState } from 'react';

import './auto-resizable-textarea.scss';

interface Props
    extends React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement> {
    mix?: string;
    maxHeight?: number;
    textareaRef?: React.MutableRefObject<HTMLTextAreaElement | null>;
}

export const AutoResizableTextarea = ({
    mix,
    value,
    maxHeight = 999,
    onChange,
    readOnly,
    textareaRef: textareaCustomRef,
    ...props
}: Props) => {
    const [textareaValue, setTextareaValue] = useState(value);

    const textareaDefaultRef = useRef<HTMLTextAreaElement>(null);
    const textareaRef = textareaCustomRef || textareaDefaultRef;

    const setNewTextareaHeight = useCallback(() => {
        const textareaElement = textareaRef.current;

        if (!textareaElement) {
            return;
        }

        textareaElement.style.height = '1px';
        textareaElement.style.height =
            (textareaElement.scrollHeight < maxHeight ? textareaElement.scrollHeight : maxHeight) + 'px';
    }, [maxHeight, textareaRef]);

    useEffect(() => {
        setNewTextareaHeight();
    }, [setNewTextareaHeight, textareaValue]);

    useEffect(() => {
        setTextareaValue(value);
    }, [value]);

    const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
        setTextareaValue(event.target.value);
        if (onChange) {
            onChange(event);
        }
    };

    return (
        <textarea
            className={cx(b('auto-resizable-textarea', { 'read-only': readOnly }), mix)}
            onChange={handleChange}
            readOnly={readOnly}
            ref={textareaRef}
            value={textareaValue}
            {...props}
        />
    );
};
